import { commonUtils } from '../common_utils';

const AUTORAHA_MIN_LOAN_AMOUNT = 3000;
const AUTORAHA_MAX_LOAN_AMOUNT = 100000;

export const autoraha = {
    removeGreenEffect() {
        $('.greenFadeEffectAutoraha').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        $('#autorahaLoanPeriod').empty();

        let startYear = 1,
            endYear = 6;
        for (let year = startYear; year <= endYear; year++) {
            $('#autorahaLoanPeriod').append(new Option(year, year));
        }

        $('#autorahaLoanPeriod').val(defaultYears);
    },
    slider() {
        let defaultYear = $('#autorahaLoanPeriod').val();
        let loanAmount = $('#autorahaLoanAmount').val();

        $('.greenFadeEffectAutoraha').addClass('updateSec');

        if (loanAmount < AUTORAHA_MIN_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.autoraha_min_loan_amount);
            loanAmount = AUTORAHA_MIN_LOAN_AMOUNT;
            $('#autorahaLoanAmount').val(loanAmount);
        }

        if (loanAmount > AUTORAHA_MAX_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.autoraha_max_loan_amount);
            loanAmount = AUTORAHA_MAX_LOAN_AMOUNT;
            $('#autorahaLoanAmount').val(loanAmount);
        }

        autoraha.loadYear(defaultYear);
        defaultYear = $('#autorahaLoanPeriod').val();

        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_autoraha'),
            data: `loanAmount=${loanAmount}&loanPeriod=${defaultYear}`,
            success(data) {
                let loanData = data.autoraha;
                let installment = '-',
                    effective = '-',
                    nominal = '-';
                if (loanData) {
                    installment = commonUtils.numberFormatByLocale(loanData.vahimmaisera.toFixed(2));
                    effective = commonUtils.numberFormatByLocale(loanData.todellinenVuosikorko.toFixed(2));
                    nominal = commonUtils.numberFormatByLocale(loanData.nimelliskorko.toFixed(2));
                }

                $('#autoraha_monthly_payment').html(installment);
                $('#autoraha_air').html(effective);
                $('#autoraha_mir').html(nominal);

                setTimeout(autoraha.removeGreenEffect, 1000);
            },
        });
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));
        let loanUrl =
            'https://rahoitushakemus.autoraha.fi/?_gl=1*16nz465*_ga*MTMzNDk4MzQ5Mi4xNzQwNDAzMTI2*_ga_GQCBPPNDNG*MTc0MTYwMzY5OC42LjAuMTc0MTYwMzY5OC4wLjAuMA';
        window.open(loanUrl, '_blank');
    },
};
